import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { createAction } from 'redux-actions';
var getArticleStart = createAction('GET_GHOST_ARTICLE_START');
var getArticleSuccess = createAction('GET_GHOST_ARTICLE_SUCCESS');
var getArticleFailure = createAction('GET_GHOST_ARTICLE_FAILURE');
/**
 * Action that handles fetching a single article from Ghost.
 *
 * ```js
 * // in a component
 * import { ghost } from '@minerva-analytics/pantheon';
 *
 * const Test = () => {
 *   const { getArticle } = ghost.hooks.useGhostActions(ghostApi);
 *   const loadArticle = () => getArticle('some-article-slug');
 *
 *   return (
 *     <button onClick={loadArticle}>Click me</button>
 *   )
 * }
 *
 * // outside of a component
 * import { ghost } from '@minerva-analytics/pantheon';
 *
 * const ghostApi = new GhostContentAPI({
 *   url: 'https://demo.ghost.io',
 *   key: 'abc123',
 *   version: "v3"
 * });
 *
 * const anotherAction = () => async (dispatch) => {
 *   dispatch(ghost.actions.getArticle(ghostApi, 'some-article-slug'));
 * };
 * ```
 *
 * @param {GhostContentAPI} ghostApi - An initialize Ghost client library
 *    https://ghost.org/docs/api/v3/javascript/content/#working-example
 * @param {String} slug - The slug for the article you want to fetch
 *
 * @returns {Function} - A thunk that can be dispatched by redux.
 */

var getArticle = function getArticle(ghostApi, slug) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (ghostApi) {
                _context.next = 2;
                break;
              }

              throw new Error('getArticle was called without a ghost API. Make sure ' + 'to call getArticle correctly: `getArticle(ghostApi, slug)`');

            case 2:
              if (slug) {
                _context.next = 4;
                break;
              }

              throw new Error('getArticle was called without a slug. Make sure ' + 'to call getArticle correctly: `getArticle(ghostApi, slug)`');

            case 4:
              dispatch(getArticleStart());
              _context.prev = 5;
              _context.next = 8;
              return ghostApi.posts.read({
                slug: slug,
                include: 'authors'
              }, {
                formats: ['html']
              });

            case 8:
              data = _context.sent;
              dispatch(getArticleSuccess(data));
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);
              dispatch(getArticleFailure(_context.t0));

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 12]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

export { getArticle, getArticleStart, getArticleSuccess, getArticleFailure };